import { freeze } from '@reduxjs/toolkit';
import { appRoutes, ISidebarLink } from '../../../path';

export const incidentNavLinks = freeze<ISidebarLink[]>(
  [
    {
      title: 'Manage Incident',
      url: appRoutes.incidents.manage,
      tooltip: {
        content: 'View and manage Incidents',
      },
    },
    {
      title: 'Calendar',
      url: appRoutes.incidents.calendar,
      tooltip: {
        content: 'View and manage the Calendar',
      },
    },
  ],
  true,
);
